/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Breadcrum from '@components/Navigation/Breadcrum';
import LeftNavCommonUI from '@components/UI/Common/LeftNavCommonUI';
import EventsCommonUI from '@components/UI/Events/EventsCommonUI';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import WrapLayout from '@Layout/WrapLayout';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/eventsService';

/* Styles */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Events Landing Page Data
 */
const SpecialEventDetail = ({ region, language, pageData }) => {
  const pConfig = pageData?.pageConfig;
  const pageName = pConfig?.pageName;
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang(region, language);
  }, [authContext, region, language]);

  // consoleLog('page', pageData);
  return (
    <WrapLayout pad={0}>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData?.availableLocales}
        pageconfig={pageData?.pageConfig}
      />
      <Breadcrum
        page={pageData?.breadcrumbs}
        alsoin={pageData?.alsoin}
        url=""
        region={region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />
      <Box as="section" className="page-wrap container-article" p="0" maxW="1920px !important" bgColor={pageName === 'lom' || pageName === 'lom-youth' ? '#F1EBDF' : ''}>
        <EventsCommonUI
          pageBody={pageData?.body}
          region={region}
          lang={language}
          pageConfig={pageData?.pageConfig}
        />
        <LeftNavCommonUI
          pageBody={pageData?.bodyLeftNavSections}
          region={region}
          lang={language}
          isLeftMenu
        />
        <EventsCommonUI
          pageBody={pageData?.bodyBottomSection}
          region={region}
          lang={language}
        />
      </Box>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const specialEventsDetailLandingPaths = config.USE_LOCAL_URL
    ? [
        `/in/en/events/special-events/bhairavi-consecration-terms-privacy`,
        `/in/en/events/special-events/saptarishi-arati`,
        `/in/en/events/special-events/lap-of-the-master`,
        `/in/en/events/special-events/exploring-spiritual-america`,
        `/in/en/events/special-events/wisdom-meditation-joy`,
        `/in/en/events/special-events/darshan`,
        `/in/en/events/special-events/yogeshwar-linga-consecration`,
        '/in/en/events/special-events/adiyogi-unveiling',
        '/in/en/events/special-events/guru-mahima-satsang',
        '/in/en/events/special-events/guru-mahima',
        '/in/en/events/special-events/sadhguru-in-dubai',
        '/in/ta/events/special-events/lap-of-master-tamil-2025',
        `/in/ta/events/special-events/guruvin-madiyil-2025`,
        `/in/en/events/special-events/guruvin-madiyil-2025`,
        `/in/en/events/special-events/guruvin-madiyil-2025-youth-offer`,
        `/in/ta/events/special-events/guruvin-madiyil-2025-youth-offer`,
      ]
    : await getLandingPaths('L2', '/events/special-events/', [
        'events/special-events/sadhguru-in-australia',
        '/events/special-events/ecstasy-of-enlightenment',
        '/events/special-events/ecstasy-of-enlightenment-new-delhi',
        '/events/special-events/ecstasy-of-enlightenment-bengaluru',
        '/events/special-events/ecstasy-of-enlightenment-mumbai',
        '/events/special-events/ecstasy-of-enlightenment-hyderabad',
        '/events/special-events/sadhguru-in-chennai',
        '/events/special-events/ecstasy-of-enlightenment-toronto',        
        '/events/special-events/ecstasy-of-enlightenment-dallas',
        '/events/special-events/ecstasy-of-enlightenment-philadelphia',
        '/events/special-events/ecstasy-of-enlightenment-london',
      ]);

  return {
    paths: specialEventsDetailLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language, event },
  req,
  context,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetails(
    region,
    language,
    `special-events/${event}`,
    { preview, data: previewData }
  );

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
      secondMenuVisible: event.indexOf('athithi') > -1 ? false : true,
    },
  };
};

export default SpecialEventDetail;
